import React, { Component } from "react";
import { Dropdown, Menu, Tooltip } from "antd";
import { withTheme } from "styled-components";
import { injectIntl } from "react-intl";
import { FormattedMessage } from "react-intl";

import AppContext from "../AppContext";

class LanguageToggle extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {};
  }
  onClick = lang => {
    this.context.changeLanguage(lang);
  };

  signInClick = lang => {
    const setLang = this.context.getLanguages()?.filter(language => language.value !== lang)[0];
    if (setLang?.value) {
      this.context.changeLanguage(setLang.value);
    }
  };

  render() {
    const menu = (
      <Menu>
        {this.context
          .getLanguages()
          ?.sort((a, b) => a.full_toggle_label?.localeCompare(b.full_toggle_label))
          ?.map(lang => (
            <Menu.Item onClick={() => this.onClick(lang?.value)} key={lang.key}>
              <FormattedMessage id={lang.full_toggle_label} />
            </Menu.Item>
          ))}
      </Menu>
    );

    return (
      <Dropdown
        overlay={menu}
        arrow
        trigger="click"
        disabled={this.props?.signIn}
        className={this.props?.className ? this.props?.className : "topbarLanguageDropdown"}
      >
        <Tooltip
          placement={"topLeft"}
          title={
            this.props?.signIn
              ? this.context.capitalizeStr(this.props.intl.formatMessage({ id: "change language to english" }))
              : null
          }
        >
          <div
            className={`topbarLanguageLabel ${this.props?.signIn && "textBold"}`}
            onClick={this.props?.signIn ? () => this.signInClick(this.context.getSelectedLanguage()) : null}
          >
            {this.props?.signIn
              ? this.context
                  .getLanguages()
                  ?.filter(language => language.value !== this.context.getSelectedLanguage())[0]?.value
              : this.context.getSelectedLanguage()}
          </div>
        </Tooltip>
      </Dropdown>
    );
  }
}

export default withTheme(injectIntl(LanguageToggle));
